import {XHRBackend, Http, RequestOptions} from "@angular/http";
import {HttpInterceptor} from "./http-interceptor";
import { LoaderEvent } from './message.event';

export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, loaderEvent:LoaderEvent): Http {
    return new HttpInterceptor(xhrBackend, requestOptions, loaderEvent);
}


// WEBPACK FOOTER //
// ./src/app/shared/http-factory.ts